/* tslint:disable */
/* eslint-disable */
/**
 * gtep-rfp-api API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0-SNAPSHOT
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface RfpResponseDto
 */
export interface RfpResponseDto {
    /**
     * 
     * @type {string}
     * @memberof RfpResponseDto
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof RfpResponseDto
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof RfpResponseDto
     */
    file: string;
}

export function RfpResponseDtoFromJSON(json: any): RfpResponseDto {
    return RfpResponseDtoFromJSONTyped(json, false);
}

export function RfpResponseDtoFromJSONTyped(json: any, ignoreDiscriminator: boolean): RfpResponseDto {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'file': json['file'],
    };
}

export function RfpResponseDtoToJSON(value?: RfpResponseDto | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'name': value.name,
        'file': value.file,
    };
}

